import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle auth errors - only logout on token expiry, not on login failures
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only auto-logout if the request had a token (authenticated request)
    // and the server says token is invalid/expired
    const hadToken = error.config?.headers?.Authorization;
    const isAuthEndpoint = error.config?.url?.includes('/auth/login') || 
                          error.config?.url?.includes('/auth/signup') ||
                          error.config?.url?.includes('/auth/reset-password') ||
                          // Google session exchange: a stale token must never trigger a hard
                          // redirect here, it would abort the OAuth callback mid-flight
                          error.config?.url?.includes('/auth/google/callback');
    
    if (error.response?.status === 401 && hadToken && !isAuthEndpoint) {
      // Token expired or invalid - clear and redirect
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
